import { z } from 'zod';
import { TimestampLike } from './timestamp-like';

export const NoteSchema = z.strictObject({
  text: z.string().min(1),
  authorId: z.string(),
  authorName: z.string(),
  createdAt: z.custom<TimestampLike>(),
});

export type Note = z.infer<typeof NoteSchema>;
